/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='sw1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw1'">SW1</vs-button>
          <vs-button :color="sel==='sw2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw2'">SW2</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">Configure VLANs</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Progress }}/6</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">SW1</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task1Sw1Items" :key="'t1-sw1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw1Completion[item.key])"></div>
                  <code class="text-base" :class="sw1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">SW2</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task1Sw2Items" :key="'t1-sw2-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw2Completion[item.key])"></div>
                  <code class="text-base" :class="sw2Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">SW2 e0/1 → Available VLAN (use show vlan)</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Progress }}/4</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">SW2</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task2Items" :key="'t2-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw2Completion[item.key])"></div>
                  <code class="text-base" :class="sw2Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 3 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task3Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task3Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task3Done?'#28C76F':'#4a5568'}">3</span>
              <span class="font-semibold text-sm flex-1">Inter-switch link e0/0 — access VLAN 100</span>
              <span class="text-xs font-medium" :class="task3Done?'text-success':'text-grey'">{{ task3Progress }}/6</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swk in ['sw1','sw2']" :key="'t3-'+swk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ swk.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in task3Items" :key="'t3-'+swk+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk)[item.key])"></div>
                    <code class="text-base" :class="getComp(swk)[item.key]?'text-success':''">{{ item.label }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 4 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task4Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task4Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task4Done?'#28C76F':'#4a5568'}">4</span>
              <span class="font-semibold text-sm flex-1">SW1 e0/1 — data VLAN 100 + voice VLAN 200</span>
              <span class="text-xs font-medium" :class="task4Done?'text-success':'text-grey'">{{ task4Progress }}/4</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">SW1</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task4Items" :key="'t4-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw1Completion[item.key])"></div>
                  <code class="text-base" :class="sw1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 5 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task5Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task5Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task5Done?'#28C76F':'#4a5568'}">5</span>
              <span class="font-semibold text-sm flex-1">SW2 e0/1 — disable CDP on interface</span>
              <span class="text-xs font-medium" :class="task5Done?'text-success':'text-grey'">{{ task5Progress }}/3</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">SW2</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task5Items" :key="'t5-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw2Completion[item.key])"></div>
                  <code class="text-base" :class="sw2Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ [sw1Completion.saved,sw2Completion.saved].filter(Boolean).length }}/2</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swk in ['sw1','sw2']" :key="'s-'+swk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ swk.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk).saved)"></div>
                    <code class="text-base" :class="getComp(swk).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='sw1'" key="sw1" id="sw1_terminal" :commands="sw1Commands" :prompt="sw1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="SW1" />
          <vue-command v-show="sel==='sw2'" key="sw2" id="sw2_terminal" :commands="sw2Commands" :prompt="sw2Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="SW2" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the task checklist. Use "show vlan" to discover the Available VLAN number.';

const mkCommands = (swk, vm) => ({
  help:       () => createStdout(HELP),
  enable:     () => vm.iosEnable(swk),
  configure:  (x) => vm.iosConfigure(swk, x),
  conf:       (x) => vm.iosConfigure(swk, x),
  vlan:       (x) => vm.iosVlan(swk, x),
  name:       (x) => vm.iosName(swk, x),
  interface:  (x) => vm.iosInterface(swk, x),
  int:        (x) => vm.iosInterface(swk, x),
  switchport: (x) => vm.iosSwitchport(swk, x),
  no:         (x) => vm.iosNo(swk, x),
  cdp:        (x) => vm.iosCdp(swk, x),
  show:       (x) => vm.iosShow(swk, x),
  exit:       () => vm.iosExit(swk),
  end:        () => vm.iosEnd(swk),
  copy:       (x) => vm.iosCopy(swk, x),
});

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/Voice_VLAN_Configuration_Sim.png',
      sel: 'sw1',
      totalScore: 0,

      sw1: { mode: 'exec', currentVlan: null, currentIf: null },
      sw2: { mode: 'exec', currentVlan: null, currentIf: null },

      // sw1: task1(4) + task3(3) + task4(4) + saved(1) = 12
      sw1Completion: {
        vlan100: false, vlan100Name: false,
        vlan200: false, vlan200Name: false,
        e00If: false, e00Access: false, e00Vlan: false,
        e01If: false, e01Access: false, e01Vlan: false, e01Voice: false,
        saved: false,
      },
      // sw2: task1(2) + task2(4) + task3(3) + task5(3) + saved(1) = 12 (e01If shared by task2+task5)
      sw2Completion: {
        vlan100: false, vlan100Name: false,
        e01If: false, e01Access: false, e01VlanAvail: false, e01NoShut: false,
        e00If: false, e00Access: false, e00Vlan: false,
        cdpRun: false, e01NoCdp: false,
        e01IfT5: false, // display-only: Task 5 re-entry of "interface e0/1" (not scored; e01If is the scored Task 2 entry)
        saved: false,
      },

      sw1Commands: null,
      sw2Commands: null,

      task1Sw1Items: [
        { key: 'vlan100',     label: 'vlan 100' },
        { key: 'vlan100Name', label: 'name Compute' },
        { key: 'vlan200',     label: 'vlan 200' },
        { key: 'vlan200Name', label: 'name Telephony' },
      ],
      task1Sw2Items: [
        { key: 'vlan100',     label: 'vlan 100' },
        { key: 'vlan100Name', label: 'name Compute' },
      ],
      task2Items: [
        { key: 'e01If',       label: 'interface e0/1' },
        { key: 'e01Access',   label: 'switchport mode access' },
        { key: 'e01VlanAvail',label: 'switchport access vlan 99' },
        { key: 'e01NoShut',   label: 'no shutdown' },
      ],
      task3Items: [
        { key: 'e00If',       label: 'interface e0/0' },
        { key: 'e00Access',   label: 'switchport mode access' },
        { key: 'e00Vlan',     label: 'switchport access vlan 100' },
      ],
      task4Items: [
        { key: 'e01If',       label: 'interface e0/1' },
        { key: 'e01Access',   label: 'switchport mode access' },
        { key: 'e01Vlan',     label: 'switchport access vlan 100' },
        { key: 'e01Voice',    label: 'switchport voice vlan 200' },
      ],
      task5Items: [
        { key: 'cdpRun',      label: 'cdp run' },
        { key: 'e01IfT5',     label: 'interface e0/1' },
        { key: 'e01NoCdp',    label: 'no cdp enable' },
      ],
    };
  },

  computed: {
    sw1Prompt() {
      const m = this.sw1.mode;
      if (m === 'config-vlan') return 'SW1(config-vlan)#';
      if (m === 'config-if')   return 'SW1(config-if)#';
      if (m === 'config')      return 'SW1(config)#';
      return 'SW1#';
    },
    sw2Prompt() {
      const m = this.sw2.mode;
      if (m === 'config-vlan') return 'SW2(config-vlan)#';
      if (m === 'config-if')   return 'SW2(config-if)#';
      if (m === 'config')      return 'SW2(config)#';
      return 'SW2#';
    },

    task1Progress() {
      const c1 = this.sw1Completion, c2 = this.sw2Completion;
      return [c1.vlan100, c1.vlan100Name, c1.vlan200, c1.vlan200Name,
              c2.vlan100, c2.vlan100Name].filter(Boolean).length;
    },
    task1Done() { return this.task1Progress === 6; },

    task2Progress() {
      const c2 = this.sw2Completion;
      return [c2.e01If, c2.e01Access, c2.e01VlanAvail, c2.e01NoShut].filter(Boolean).length;
    },
    task2Done() { return this.task2Progress === 4; },

    task3Progress() {
      const c1 = this.sw1Completion, c2 = this.sw2Completion;
      return [c1.e00If, c1.e00Access, c1.e00Vlan,
              c2.e00If, c2.e00Access, c2.e00Vlan].filter(Boolean).length;
    },
    task3Done() { return this.task3Progress === 6; },

    task4Progress() {
      const c1 = this.sw1Completion;
      return [c1.e01If, c1.e01Access, c1.e01Vlan, c1.e01Voice].filter(Boolean).length;
    },
    task4Done() { return this.task4Progress === 4; },

    task5Progress() {
      const c2 = this.sw2Completion;
      return [c2.cdpRun, c2.e01IfT5, c2.e01NoCdp].filter(Boolean).length;
    },
    task5Done() { return !!(this.sw2Completion.cdpRun && this.sw2Completion.e01NoCdp); },

    saveDone() { return this.sw1Completion.saved && this.sw2Completion.saved; },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    this.sw1Commands = mkCommands('sw1', this);
    this.sw2Commands = mkCommands('sw2', this);
  },

  methods: {
    getComp(k) { return this[k + 'Completion']; },

    dot(val) {
      return { width: '8px', height: '8px', background: val ? '#28C76F' : 'transparent', border: '2px solid ' + (val ? '#28C76F' : '#6b7280') };
    },

    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    normalizeIf(ifStr) {
      return (ifStr || '').toLowerCase()
        .replace(/^fastethernet/, '')
        .replace(/^ethernet/, '')
        .replace(/^fa/, '')
        .replace(/^e(?=\d)/, '')
        .trim();
    },

    updateScore() {
      let score = 0;
      // e01IfT5 is a display-only flag for the Task 5 re-entry of "interface e0/1" — not scored.
      [this.sw1Completion, this.sw2Completion].forEach(c =>
        Object.entries(c).forEach(([k, v]) => { if (v && k !== 'e01IfT5') score++; })
      );
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      // sw1(12) + sw2(12) = 24 total keys
      if (score >= 24) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    iosEnable(swk) {
      this[swk].mode = 'exec';
      return createStdout('');
    },

    iosConfigure(swk, x) {
      const s = this[swk];
      if (s.mode !== 'exec') return createStderr('% Already in configuration mode — type "end" to return to exec first');
      if (x._[1] === 'terminal' || x._[1] === 't') {
        s.mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(swk) {
      const s = this[swk];
      if (s.mode === 'config-if' || s.mode === 'config-vlan') {
        s.mode = 'config';
        s.currentVlan = null;
        s.currentIf = null;
      } else if (s.mode === 'config') {
        s.mode = 'exec';
      }
      return createStdout('');
    },

    iosEnd(swk) {
      this[swk].mode = 'exec';
      this[swk].currentVlan = null;
      this[swk].currentIf = null;
      return createStdout('');
    },

    iosVlan(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config' && s.mode !== 'config-vlan') {
        return createStderr('% Invalid input detected — must be in global or VLAN configuration mode');
      }
      const vlanId = String(x._[1] || '');
      if (!vlanId || isNaN(vlanId)) return createStderr('% Invalid input detected');

      s.mode = 'config-vlan';
      s.currentVlan = vlanId;
      s.currentIf = null;

      const c = this[swk + 'Completion'];
      if (vlanId === '100' && !c.vlan100) { c.vlan100 = true; this.updateScore(); }
      else if (vlanId === '200' && swk === 'sw1' && !c.vlan200) { c.vlan200 = true; this.updateScore(); }

      return createStdout('');
    },

    iosName(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config-vlan') return createStderr('% Invalid input detected — must be in VLAN configuration mode');
      const nameRaw = (x._[1] || '');
      if (!nameRaw) return createStderr('% Invalid input detected');
      const nameUp = nameRaw.toUpperCase();
      const c = this[swk + 'Completion'];

      if (s.currentVlan === '100' && nameUp === 'COMPUTE' && !c.vlan100Name) {
        c.vlan100Name = true; this.updateScore();
        if (swk === 'sw1') {
          return createStdout(this.guide(
            'VLAN 100 named Compute on SW1. This is the data VLAN — workstations send untagged frames on this VLAN. ' +
            '→ Create VLAN 200 for voice traffic: "vlan 200".'
          ));
        }
        return createStdout(this.guide(
          'VLAN 100 named Compute on SW2. SW2 only needs the Compute VLAN — it has no voice-capable ports. ' +
          '→ Configure Task 2: type "show vlan" to find the Available VLAN number, then configure interface e0/1.'
        ));
      }

      if (s.currentVlan === '200' && swk === 'sw1' && nameUp === 'TELEPHONY' && !c.vlan200Name) {
        c.vlan200Name = true; this.updateScore();
        return createStdout(this.guide(
          'VLAN 200 named Telephony on SW1. Separating voice traffic onto a dedicated VLAN enables QoS policies that prioritize voice over data and simplifies troubleshooting — IP phones send voice frames tagged with VLAN 200 and data frames untagged on VLAN 100. ' +
          '→ Move to SW2 and configure Task 1 there: "vlan 100" then "name Compute".'
        ));
      }

      return createStdout('');
    },

    iosInterface(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config') return createStderr('% Invalid input detected — must be in global configuration mode');
      let ifArg = String(x._[1] || '');
      if (x._[2] && /^\d+\/\d+/.test(String(x._[2]))) ifArg = ifArg + x._[2];
      let ifNorm = this.normalizeIf(ifArg);

      // E0/0 → fa0/24 in Packet Tracer; accept fa0/24 as an alias for e0/0
      if (ifNorm === '0/24') ifNorm = '0/0';

      s.mode = 'config-if';
      s.currentIf = ifNorm;
      s.currentVlan = null;

      const c = this[swk + 'Completion'];
      if (ifNorm === '0/0' && !c.e00If) { c.e00If = true; this.updateScore(); }
      else if (ifNorm === '0/1' && !c.e01If) { c.e01If = true; this.updateScore(); }
      // SW2 re-entry of e0/1 for Task 5 (after "cdp run") — mark the Task 5 step only now,
      // not back in Task 2 when e0/1 was first configured.
      else if (ifNorm === '0/1' && swk === 'sw2' && c.cdpRun && 'e01IfT5' in c && !c.e01IfT5) { c.e01IfT5 = true; this.updateScore(); }

      return createStdout('');
    },

    iosSwitchport(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in interface configuration mode');
      const c = this[swk + 'Completion'];
      const sub1 = (x._[1] || '').toLowerCase();
      const sub2 = (x._[2] || '').toLowerCase();
      const ifn = s.currentIf;

      // switchport mode access
      if (sub1 === 'mode' && sub2 === 'access') {
        if (ifn === '0/0' && !c.e00Access) {
          c.e00Access = true; this.updateScore();
          return createStdout(this.guide(
            `${swk.toUpperCase()} e0/0 set to access mode. This is the inter-switch link — access mode places it into a single VLAN (no trunking needed here since only VLAN 100 traverses this link). ` +
            '→ "switchport access vlan 100".'
          ));
        }
        if (ifn === '0/1' && !c.e01Access) {
          c.e01Access = true; this.updateScore();
          if (swk === 'sw1') {
            return createStdout(this.guide('SW1 e0/1 set to access mode. This port connects to an IP phone + PC. → "switchport access vlan 100" to assign the data VLAN.'));
          }
          return createStdout(this.guide('SW2 e0/1 set to access mode. → "switchport access vlan 99" to assign the Available VLAN.'));
        }
        return createStdout('');
      }

      // switchport access vlan <id>
      if (sub1 === 'access' && sub2 === 'vlan') {
        const vlanId = String(x._[3] || '');
        if (ifn === '0/0' && vlanId === '100' && !c.e00Vlan) {
          c.e00Vlan = true; this.updateScore();
          const swName = swk.toUpperCase();
          const other = swk === 'sw1' ? 'SW2' : 'SW1';
          return createStdout(this.guide(
            `${swName} e0/0 assigned to VLAN 100 (Compute). Traffic between SW1 and SW2 now travels tagged as VLAN 100 across this access link. ` +
            (c.e00Vlan && this.getComp(swk === 'sw1' ? 'sw2' : 'sw1').e00Vlan
              ? '✓ Both sides configured.'
              : `→ Configure the same on ${other} e0/0.`)
          ));
        }
        if (swk === 'sw1' && ifn === '0/1' && vlanId === '100' && !c.e01Vlan) {
          c.e01Vlan = true; this.updateScore();
          return createStdout(this.guide(
            'SW1 e0/1 assigned to VLAN 100 (Compute) as the data VLAN. PC traffic from the IP phone pass-through port will be untagged and placed into VLAN 100. ' +
            '→ "switchport voice vlan 200" to assign the voice VLAN.'
          ));
        }
        if (swk === 'sw2' && ifn === '0/1' && vlanId === '99' && !c.e01VlanAvail) {
          c.e01VlanAvail = true; this.updateScore();
          return createStdout(this.guide(
            'SW2 e0/1 assigned to VLAN 99 (Available). VLAN 99 is a pre-existing VLAN reserved for this purpose — "show vlan" was needed to discover its number before assigning it. ' +
            '→ "no shutdown" to bring the interface up.'
          ));
        }
        return createStdout('');
      }

      // switchport voice vlan <id>
      if (sub1 === 'voice' && sub2 === 'vlan') {
        const vlanId = String(x._[3] || '');
        if (swk === 'sw1' && ifn === '0/1' && vlanId === '200' && !c.e01Voice) {
          c.e01Voice = true; this.updateScore();
          return createStdout(this.guide(
            'Voice VLAN 200 (Telephony) assigned to SW1 e0/1. ' +
            'The IP phone sends voice frames tagged with VLAN 200; PC traffic connected through the phone passes through untagged on VLAN 100. ' +
            'Cisco phones learn the voice VLAN via CDP — the switch advertises VLAN 200 to the phone automatically. ' +
            '→ Switch to SW2 and configure Task 5: "cdp run" then disable CDP on e0/1.'
          ));
        }
        return createStdout('');
      }

      return createStderr('% Invalid input detected');
    },

    iosNo(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in interface configuration mode');
      const sub1 = (x._[1] || '').toLowerCase();
      const sub2 = (x._[2] || '').toLowerCase();
      const c = this[swk + 'Completion'];
      const ifn = s.currentIf;

      if (sub1 === 'shutdown') {
        if (swk === 'sw2' && ifn === '0/1' && !c.e01NoShut) {
          c.e01NoShut = true; this.updateScore();
          return createStdout(this.guide(
            'Interface e0/1 on SW2 brought administratively up. ' +
            'Switch interfaces default to no shutdown, but explicitly enabling the interface ensures it is active even if it was previously disabled. ' +
            '→ Configure Task 3: "interface e0/0" on both switches to set up the inter-switch link.'
          ));
        }
        return createStdout('');
      }

      if (sub1 === 'cdp' && sub2 === 'enable') {
        if (swk === 'sw2' && ifn === '0/1' && !c.e01NoCdp) {
          c.e01NoCdp = true; this.updateScore();
          return createStdout(this.guide(
            'CDP disabled on SW2 e0/1 only. This prevents SW2 from advertising its identity and capabilities to unknown devices (such as customer equipment) on this access port. ' +
            'Global CDP remains enabled — SW1 and SW2 still use CDP on the uplink (e0/0) for neighbor discovery. ' +
            '→ Save both switches: "end" then "copy running-config startup-config".'
          ));
        }
        return createStdout('');
      }

      return createStderr('% Invalid input detected');
    },

    iosCdp(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config') return createStderr('% Invalid input detected — must be in global configuration mode');
      const sub1 = (x._[1] || '').toLowerCase();
      const c = this[swk + 'Completion'];

      if (sub1 === 'run' && swk === 'sw2' && !c.cdpRun) {
        c.cdpRun = true; this.updateScore();
        return createStdout(this.guide(
          'CDP enabled globally on SW2. CDP is Cisco-proprietary and is on by default — this command makes the intent explicit. ' +
          '"no cdp enable" on a specific interface overrides the global setting for that port only, allowing per-interface control without disabling CDP network-wide. ' +
          '→ "interface e0/1" to enter the interface and disable CDP there.'
        ));
      }

      return createStdout('');
    },

    iosShow(swk, x) {
      const sub1 = (x._[1] || '').toLowerCase();
      if (sub1 !== 'vlan') return createStderr('% Invalid input detected');

      const c = this[swk + 'Completion'];
      const rows = [];
      rows.push('1    default                          active');
      rows.push('99   Available                        active');
      if (c.vlan100 && c.vlan100Name) rows.push('100  Compute                          active');
      else if (c.vlan100)             rows.push('100  VLAN0100                         active');
      if (swk === 'sw1') {
        if (c.vlan200 && c.vlan200Name) rows.push('200  Telephony                        active');
        else if (c.vlan200)             rows.push('200  VLAN0200                         active');
      }
      rows.push('1002 fddi-default                     act/unsup');
      rows.push('1003 token-ring-default               act/unsup');
      rows.push('1004 fddinet-default                  act/unsup');
      rows.push('1005 trnet-default                    act/unsup');

      return createStdout(
        'VLAN Name                             Status    Ports<br>' +
        '---- -------------------------------- --------- ------<br>' +
        rows.join('<br>')
      );
    },

    iosCopy(swk, x) {
      const s = this[swk];
      if (s.mode !== 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" first');
      const c = this[swk + 'Completion'];
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout(
          'Destination filename [startup-config]?<br>Building configuration...<br>[OK]' +
          this.guide(
            `${swk.toUpperCase()} configuration saved to NVRAM. ` +
            (this.saveDone ? '✓ Both switches saved — simulation complete!' : '→ Save the remaining switch.')
          )
        );
      }
      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#sw1_terminal, #sw2_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

